import { MisField } from "../../interfaces/ActionStartResponse";

const DATE_WORD = /\bdate\b/i;
const LOCAL_DATE_TIME = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?$/;

/** True when the label contains the exact word "date" in any case. */
export function isDateLabel(label: string): boolean {
    return DATE_WORD.test(label);
}

/**
 * Normalises a stored MIS value for a datetime-local input.
 * Returns "" for empty, "YYYY-MM-DDTHH:mm" for a valid date-time, or null when the text is not a date-time.
 */
export function toDateTimeLocalValue(value: string | undefined): string | null {
    if (!value) return "";

    const match = LOCAL_DATE_TIME.exec(value.trim());
    if (!match) return null;

    const [, y, mo, d, h, mi] = match;
    const date = new Date(Number(y), Number(mo) - 1, Number(d), Number(h), Number(mi));
    const valid =
        date.getFullYear() === Number(y) &&
        date.getMonth() === Number(mo) - 1 &&
        date.getDate() === Number(d) &&
        date.getHours() === Number(h) &&
        date.getMinutes() === Number(mi);

    return valid ? `${y}-${mo}-${d}T${h}:${mi}` : null;
}

/** A date picker is used only for date-labelled TextInput fields whose stored value is empty or a valid date-time. */
export function usesDatePicker(field: MisField, value: string | undefined): boolean {
    return field.fieldType === "TextInput" && isDateLabel(field.label) && toDateTimeLocalValue(value) !== null;
}
